import { useState } from 'react';
import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/home';

const coverImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Solo%20leveling%20manhwa%20cover%20style%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%20in%20epic%20battle%20pose%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20Korean%20webtoon%20art%20style%2C%20warm%20dark%20tones&width=600&height=375&seq=solo-leveling-cover-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=True%20Beauty%20manhwa%20cover%20style%2C%20beautiful%20Korean%20girl%20with%20makeup%20transformation%2C%20soft%20romantic%20atmosphere%2C%20pastel%20color%20palette%2C%20Korean%20webtoon%20art%20style%2C%20gentle%20warm%20lighting&width=600&height=800&seq=true-beauty-cover-02&orientation=portrait',
  3: 'https://readdy.ai/api/search-image?query=Omniscient%20reader%20manhwa%20cover%20style%2C%20apocalyptic%20fantasy%20scene%20with%20mysterious%20protagonist%2C%20dramatic%20atmosphere%2C%20cosmic%20elements%2C%20Korean%20webtoon%20art%20style%2C%20dark%20warm%20undertones&width=600&height=800&seq=omniscient-reader-cover-03&orientation=portrait',
  4: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20manhwa%20cover%2C%20elegant%20duke%20and%20beautiful%20lady%20in%20royal%20setting%2C%20contract%20marriage%20theme%2C%20lavish%20gown%2C%20Korean%20webtoon%20art%20style%2C%20warm%20golden%20light&width=600&height=800&seq=duke-contract-cover-04&orientation=portrait',
  5: 'https://readdy.ai/api/search-image?query=Villainess%20manhwa%20cover%2C%20elegant%20dark-haired%20princess%20in%20royal%20palace%2C%20string%20puppet%20theme%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20rich%20dark%20warm%20colors&width=600&height=800&seq=villainess-puppet-cover-05&orientation=portrait',
  6: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manhwa%20cover%2C%20sword%20master%20in%20dynamic%20fighting%20pose%2C%20ancient%20Chinese%20martial%20arts%20aesthetic%2C%20dramatic%20energy%20effects%2C%20Korean%20webtoon%20art%20style%2C%20warm%20fiery%20tones&width=600&height=800&seq=sword-emperor-return-cover-06&orientation=portrait',
};

export default function HotComicsSection() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            热门漫画推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选优质韩漫，无删减、高清画质，下拉式流畅阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotComics.map((comic, idx) => {
            const isFirst = idx === 0;
            return (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className={`relative group overflow-hidden rounded-lg cursor-pointer ${
                  isFirst ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
                style={{ aspectRatio: isFirst ? '16/10' : '3/4' }}
                onMouseEnter={() => setHoveredId(comic.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <img
                  src={coverImages[comic.id]}
                  alt={comic.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500/90 text-white text-xs font-medium">
                      {comic.rating}
                    </span>
                    <span className="px-2 py-0.5 rounded-full bg-white/20 text-white text-xs">
                      {comic.status}
                    </span>
                    <span className="text-white/60 text-xs">{comic.chapters}话</span>
                  </div>
                  <h3 className="text-white text-lg md:text-xl font-heading font-bold mb-1">
                    {comic.title}
                  </h3>
                  <p className="text-white/60 text-xs mb-1">{comic.author}</p>

                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      hoveredId === comic.id ? 'max-h-20 opacity-100 mt-2' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <p className="text-white/70 text-xs leading-relaxed line-clamp-2">
                      {comic.description}
                    </p>
                  </div>
                </div>

                <div className="absolute top-3 left-3 flex gap-1.5 flex-wrap">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-black/40 backdrop-blur-sm text-white/80 text-xs">
                      {tag}
                    </span>
                  ))}
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/dong-zuo"
            className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 hover:border-accent-500 text-foreground-700 hover:text-accent-500 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部热门漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}